import { useEffect, useState } from 'react';
import actions from 'actions';

const EMPTY = { unsplashPhotos: [], userPhotos: [] };

// The photos of the spot a form is showing.
//
// A spot from the light catalogue carries none. It used to: get-all-light
// pre-hydrated every spot that had no description, and that loop was what made
// the endpoint spend its whole budget once the description left the payload, so
// it was deleted - along with the one thing these forms were quietly getting
// from it. They read the single spot they are showing instead, which is one
// request rather than thirty thousand.
//
// A spot created a moment ago is already carrying the photo it was created from
// and has no stored id to read yet, so it is used exactly as it stands.
export const useSpotPhotos = spot => {
  const spotId = spot && spot.id;
  const isAlreadyHydrated = Boolean(spot && spot.isHydrated);
  const [fetched, setFetched] = useState(null);

  useEffect(() => {
    if (isAlreadyHydrated || !spotId) {
      return undefined;
    }

    let cancelled = false;

    setFetched(null);

    actions.spots
      .getHydratedById(spotId)
      .then(({ spot: hydrated }) => {
        if (!cancelled) {
          setFetched({
            unsplashPhotos: hydrated.photosHydrated || [],
            userPhotos: hydrated.userPhotosHydrated || [],
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setFetched(EMPTY);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [spotId, isAlreadyHydrated]);

  if (isAlreadyHydrated) {
    return {
      unsplashPhotos: spot.photosHydrated || [],
      userPhotos: spot.userPhotosHydrated || [],
      isReady: true,
    };
  }

  // Empty and not-read-yet look the same in the lists and are nothing alike to
  // anything that counts them.
  return { ...(fetched || EMPTY), isReady: Boolean(fetched) || !spotId };
};

export default useSpotPhotos;
